(() => {
  function initializeCartUI() {
  const dialog = document.querySelector('[data-sun-cart-dialog]');
  const cartLink = document.querySelector('.sun-header #cart-icon-bubble');
  if (!dialog || !cartLink) return;

  const pendingForms = new WeakSet();
  const supportsDialog = typeof dialog.showModal === 'function';
  const cartUrl = window.routes?.cart_url || '/cart';
  const cartAddUrl = window.routes?.cart_add_url || '/cart/add';

  function currentCount() {
    return Number.parseInt(cartLink.querySelector('.lb-v1-cart-count')?.textContent || '0', 10) || 0;
  }

  function setCount(count) {
    let badge = cartLink.querySelector('.lb-v1-cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'lb-v1-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        cartLink.querySelector('.visually-hidden')?.before(badge);
      }
      badge.textContent = String(count);
    } else {
      badge?.remove();
    }

    const accessibleCount = cartLink.querySelector('.visually-hidden');
    if (accessibleCount) accessibleCount.textContent = `Cart with ${count} ${count === 1 ? 'item' : 'items'}`;
  }

  async function refreshCount(quantityAdded) {
    const previousCount = currentCount();
    try {
      const response = await fetch(`${cartUrl}.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Cart count unavailable');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count)) throw new Error('Invalid cart count');
      setCount(cart.item_count);
    } catch {
      // The add response was confirmed, so keep the visible count useful if the
      // separate cart fetch fails. A later page load will use Shopify's count.
      setCount(previousCount + quantityAdded);
    }
  }

  function showAdded(quantityAdded = 1) {
    if (!supportsDialog) {
      window.location.assign(cartUrl);
      return;
    }
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('#SunCartAddedHeading')?.focus();
    void refreshCount(quantityAdded);
  }

  function showError(form, message) {
    let error = form.querySelector('[data-sun-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'sun-purchase-note';
      error.dataset.sunCartError = '';
      error.setAttribute('role', 'alert');
      form.querySelector('.sun-purchase-row')?.after(error);
    }
    error.textContent = message;
    error.hidden = false;
  }

  async function addFromSunsetForm(form) {
    const button = form.querySelector('[data-sun-buy]');
    if (!button || pendingForms.has(form)) return;
    const body = new FormData(form);
    const quantity = Math.max(1, Number.parseInt(body.get('quantity') || '1', 10) || 1);
    const originalLabel = button.textContent;
    const variantInputs = [...form.querySelectorAll('input[name="id"]')];
    const disabledVariants = variantInputs.map((input) => input.disabled);
    pendingForms.add(form);
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = 'Adding…';
    variantInputs.forEach((input) => { input.disabled = true; });
    form.querySelector('[data-sun-cart-error]')?.setAttribute('hidden', '');

    try {
      const response = await fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body,
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const detail = typeof result.description === 'string' ? result.description : result.message;
        showError(form, typeof detail === 'string' ? detail : 'This blanket could not be added. Please try again.');
      } else if (result.id || Array.isArray(result.items)) {
        showAdded(quantity);
      } else {
        showError(form, 'We couldn’t confirm the add. Check your cart before trying again.');
      }
    } catch {
      // A network error after submission may still have added the item.
      showError(form, 'We couldn’t confirm the add. Check your cart before trying again.');
    } finally {
      variantInputs.forEach((input, index) => { input.disabled = disabledVariants[index]; });
      const selectedVariant = form.querySelector('input[name="id"]:checked');
      const available = selectedVariant?.dataset.sunAvailable === 'true';
      button.textContent = available ? originalLabel : 'Coming soon';
      button.disabled = !available;
      form.removeAttribute('aria-busy');
      pendingForms.delete(form);
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== 'SunProductForm') return;
    if (!window.fetch || !window.FormData || !supportsDialog) return;
    event.preventDefault();
    // Shopify's earlier bubble listener also handles native product forms.
    // Own this one form before that listener can redirect to /cart.
    event.stopImmediatePropagation();
    if (pendingForms.has(form) || !form.reportValidity()) return;
    void addFromSunsetForm(form);
  }, true);

  document.addEventListener('lb:sunset-cart-added', (event) => {
    showAdded(Math.max(1, Number.parseInt(event.detail?.quantity || '1', 10) || 1));
  });

  dialog.querySelectorAll('[data-sun-cart-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });

  window.lbSunsetCartUI = { showAdded };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCartUI, { once: true });
  } else {
    initializeCartUI();
  }
})();
